import { AxiosResponse } from 'axios'

import axios from '../../axios'

export const downloadManual = async (
  filePath: string
): Promise<AxiosResponse> => {
  const response = await axios
    .get(`/api/manual/download`, {
      params: { filePath },
    })
    .catch((error) => {
      return error.response
    })

  return response
}
